import { render, staticRenderFns } from "./alert-sin-asignar.vue?vue&type=template&id=1817b5c2"
import script from "./alert-sin-asignar.vue?vue&type=script&lang=js"
export * from "./alert-sin-asignar.vue?vue&type=script&lang=js"
import style0 from "./alert-sin-asignar.vue?vue&type=style&index=0&id=1817b5c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports